import {
  IAPICanOpenInvoiceBillItem,
  IAPICompanyFullInfo,
  IAPIFeeCenterMailManageItem,
  IAPIInvoiceHeader,
  IAPIStudioMemberHasPermissionItem,
} from '../../../../model/api-modules';
import { ApplyInvoice } from './apply';
import { MoneyCard } from './apply/money-card';
import { InvoiceEmails } from './emails';
import { InvoiceHeader } from './header';
import styles from './index.module.scss';
import { InvoiceBillList } from './bill-list';
import { useState } from 'react';
import { CommonPrompt } from '../../../../components/prompt';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../store/reducers';
import { ApplyInvoiceHistory } from './history';
import { useHistory } from 'react-router-dom';
import { goInvoicePage } from './lib';
import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly companyInfo?: IAPICompanyFullInfo | null;
  readonly owner?: IAPIStudioMemberHasPermissionItem;
}

export const InvoiceManage = (props: IProps) => {
  const { companyInfo, owner } = props;
  const history = useHistory();
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const [canOpenMoney, setCanOpenMoney] = useState<number>(0);
  const [selectBills, setSelectBills] = useState<
    ReadonlyArray<IAPICanOpenInvoiceBillItem>
  >([]);
  const [invoice, setInvoice] = useState<IAPIInvoiceHeader>();
  const [emailList, setEmailList] = useState<
    ReadonlyArray<IAPIFeeCenterMailManageItem>
  >([]);

  if (!companyInfo) {
    return null;
  }
  if (location.pathname.includes('/fee/invoice-manage/history')) {
    return <ApplyInvoiceHistory />;
  }
  if (location.pathname.includes('/fee/invoice-manage/apply')) {
    if (invoice && owner && selectBills.length && emailList && companyInfo) {
      return (
        <ApplyInvoice
          selectBills={selectBills}
          invoice={invoice}
          emails={emailList}
          companyInfo={companyInfo}
          owner={owner}
          onReload={(newEmails, newHeader) => {
            setEmailList(newEmails);
            setInvoice(newHeader);
          }}
        />
      );
    }
    goInvoicePage(history, '');
  }

  const onApply = (bills: IAPICanOpenInvoiceBillItem[]) => {
    if (!selectStudio) {
      return;
    }
    setSelectBills(bills);
    goInvoicePage(history, 'apply');
  };

  return (
    <div className={styles.invoicePage}>
      <div className={styles.headInfo}>
        <CommonPrompt>
          <div>
            {getFormatMessage('invoice_info_line_1')}
            <span className={styles.importText}>
              {getFormatMessage('invoice_info_line_2')}
            </span>
            {getFormatMessage('invoice_info_line_3')}
          </div>
          <div>
            {getFormatMessage('invoice_info_line_4')}
            <span className={styles.importText}>
              {getFormatMessage('invoice_info_line_5')}
            </span>
            {getFormatMessage('invoice_info_line_6')}
          </div>
        </CommonPrompt>
      </div>
      <div className={styles.headCards}>
        <MoneyCard money={canOpenMoney} />
        <InvoiceHeader
          companyInfo={companyInfo}
          onChange={(data) => {
            setInvoice(data);
          }}
        />
        <InvoiceEmails
          owner={owner}
          onChange={(data) => {
            setEmailList(data);
          }}
        />
      </div>
      <InvoiceBillList
        onApply={onApply}
        onChange={(val) => setCanOpenMoney(val)}
      />
    </div>
  );
};
